<template>
<div id="app">
  <keep-alive :include="viewKeepAlive">
    <router-view></router-view>
  </keep-alive>
</div>
</template>
<script>
import store, { updateUserData, updateUserPermission } from './store'
import { defback, closeWebView } from './utils/jsb-helper'
import { getUserPermission } from './api/index'
import { PUBLIC_PATH } from './constants'
export default {
  name: 'App',
  created() {
    console.info("env =", process.env)
    // 设置标题
    window.qing.call('setWebViewTitle', {
      'title': this.$t('title')
    })
    // 自定义返回
    // defback(() => {
    //   // 如果导航隐藏，说明返回即退出当前页面
    //   if (this.$route.path === "/") {
    //     closeWebView()
    //     return
    //   }
    //   this.$router.go(-1)
    //   return
    // })
    // 设置标题
    window.qing.call('getPersonInfo', {
      success: (result) => {
        if (result.success) {
          console.info('getPersonInfo success', result)
          const userInfo = { ...result.data, userId: result.data.wbuserid, networkId: result.data.wbnetworkid }
          const { jobNo } = userInfo
          this.getUserPermission(jobNo)
          delete userInfo.wbuserid
          delete userInfo.wbnetworkid
          store.commit(updateUserData, userInfo);
          window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
        } else if (result && (result.success === "false" || result.success === false)) {
          console.error('getPersonInfo error', result)
        }
      },
      error: (err) => {
        console.error('getPersonInfo error', err)
      }
    })
    // web test
    // if (!window.sessionStorage.getItem("userInfo")) {
    //   setTimeout(() => {
    //     const testData = { userId: "6205dbc660b29097ca0f4f93", jobNo: "80366143", networkId: "6089516d60b2f949b87b9919", name: "康检(KangJian)" }
    //     // const testData = { userId: "61bc45d260b27e91f52c7df4", jobNo: "test_026", networkId: "6089516d60b2f949b87b9919", name: "测试26" }
    //     store.commit(updateUserData, testData);
    //     const { jobNo } = testData
    //     this.getUserPermission(jobNo)
    //   }, 200)
    // }
  },
  computed: {
    viewKeepAlive() {
      const openKeepAliveRouterNames = this.$router.options.routes.filter(v => v.meta.keepAlive).map(v => v.name)
      return openKeepAliveRouterNames
    }
  },
  methods: {
    getUserPermission(jobNo) {
      if (!jobNo) {
        return
      }
      getUserPermission(jobNo)
        .then(res => {
          if (res && res.data) {
            store.commit(updateUserPermission, res.data)
          }
          else {
            store.commit(updateUserPermission, [])
          }
        })
        .catch(err => {
          console.log("getUserPermission err", err)
        })
    }

  }
}
</script>
<style
  lang="scss"
  scoped
></style>
